import { get, httpDelete, patch, post } from '../../utils/http';

export const fetchBranchCostCenters = ({ accountId, branchId }) =>
  get(`/accounts/${accountId}/branches/${branchId}/cost-centers`);

export const addBranchCostCenter = ({ accountId, branchId, name, identifier }) =>
  post(`/accounts/${accountId}/branches/${branchId}/cost-centers`, { name, identifier });

export const updateBranchCostCenter = ({ costCenterId, accountId, branchId, name, identifier }) =>
  patch(`/accounts/${accountId}/branches/${branchId}/cost-centers/${costCenterId}`, { name, identifier });

export const deleteBranchCostCenter = ({ costCenterId, accountId, branchId }) =>
  httpDelete(`/accounts/${accountId}/branches/${branchId}/cost-centers/${costCenterId}`);

export const addBulkBranchCostCenters = ({ accountId, branchId, costCenters }) =>
  post(`/accounts/${accountId}/branches/${branchId}/cost-centers/bulk`, { costCenters });
